import type {
    Exemplar,
    ExemplarWithDocumentAndDiscardion,
    ViewableExemplar,
    ViewableExemplarWithDocument
} from 'typings/portaro.be.types';
import {exists} from 'shared/utils/custom-utils';

export function isViewableExemplar(exemplar: Exemplar): exemplar is ViewableExemplar {
    return 'availability' in exemplar && exists(exemplar.availability);
}

export function isExemplarWithDocumentAndDiscardion(exemplar: Exemplar): exemplar is ExemplarWithDocumentAndDiscardion {
    return 'record' in exemplar && exists(exemplar.record);
}

export function isViewableExemplarWithDocument(exemplar: Exemplar): exemplar is ViewableExemplarWithDocument {
    return isViewableExemplar(exemplar) && 'document' in exemplar && exists(exemplar.document);
}